import styles from './Tabs.module.scss';
import cx from 'classnames';
import { Text } from 'components';
import { Icon, Icons } from 'components/Icon/Icon';
import { FeedMessagesAmount } from 'services/patientService';
import { selectFeedMessagesAmount } from 'store/dashboard/selectors';
import { dashboardActions } from 'store/dashboard/slice';
import { useDispatch, useSelector } from 'store/utils';

type Tab = {
  key: keyof FeedMessagesAmount;
  name: string;
  iconName: Icons;
};

const tabs: Tab[] = [
  { key: 'newPatients', name: 'New patients', iconName: 'Diagnosis' },
  { key: 'letterReview', name: 'Letter Review', iconName: 'LetterBold' },
  { key: 'inTreatment', name: 'In Treatment', iconName: 'InTreatmentBold' },
  { key: 'finished', name: 'Finished', iconName: 'FinishedBold' },
  { key: 'outOfTreatment', name: 'Out of Treatment', iconName: 'OutOfTreatment' },
];

type Props = {
  activeTab: keyof FeedMessagesAmount;
  setActiveTab(value: keyof FeedMessagesAmount): void;
};

export const Tabs = ({ activeTab, setActiveTab }: Props) => {
  const dispatch = useDispatch();

  const messagesAmount = useSelector(selectFeedMessagesAmount);

  const resetPageAndChangeTab = (tabname: keyof FeedMessagesAmount) => {
    if (activeTab !== tabname) {
      dispatch(dashboardActions.setFeedFilter({ page: 0 }));
      setActiveTab(tabname);
    }
  };

  return (
    <div className={styles.container}>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={cx(styles.tab, { [styles.isActive]: tab.key === activeTab })}
          onClick={() => resetPageAndChangeTab(tab.key)}>
          <Icon name={tab.iconName} />
          <Text type="overline">{tab.name}</Text>
          {!!messagesAmount[tab.key] && (
            <div className={styles.counter}>
              <Text type="body1" className={cx({ [styles.counterTextPadding]: messagesAmount[tab.key] > 99 })}>
                {messagesAmount[tab.key]}
              </Text>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
